<template>
  <Wrapper id="sidebar-design-desktop" class="p-gd-2 h-100">

    <div class="panel-page h-100">
      <div class="panel-page-name pb-gd-2">
        <div class="d-flex justify-content-between align-items-center">
          <div class="text-truncate" style="width: 325px">
            <span class="mr-5" v-if="sitePageID == siteMainPageID">
              <i class="far fa-home text-gray-dark fs-20"></i>
            </span>
            <span class="fs-db-28" v-b-popover.hover.top="selectedPageName">
              {{ $t("engine.sidebar.index.lblPage", languageEngine) }}:
              {{ selectedPageName }}
            </span>
            {{ lblExample }}
          </div>
          <span class="cursor-pointer ml-5" @click="managepage" v-if="!isExamplePage">
            <i class="far fa-edit fs-18"></i>
          </span>
        </div>
      </div>
      <div class="panel-page-section-count pb-gd-1 d-flex justify-content-between fs-sa-14">
        <span>{{$t('engine.sidebar.index.lblSectionOnPage', languageEngine)}}</span>
        <span :class="{'text-danger': sections.length >= limit.section}"><span class="fw-bold">{{sections.length}}/{{limit.section}}</span> {{$t('engine.sidebar.index.lblSection', languageEngine)}}</span>
      </div>
      <div class="panel-page-content">
        <div class="list-scroll">
          <template>
            <!-- PageContent -->
            <div id="page-sections-list">
              <!-- Header -->
              <PanelItem
                button
                id="header-section"
                class="d-flex align-items-center mb-gd-1"
                @mouseover="!dragging && elHover({ elementID: 'HEADER' })"
                @mouseleave="!dragging && elHover({ elementID: undefined })"
                @click="!dragging && elActive({ elementID: 'header' })"
                :class="{
                  hover: hoverSection('HEADER') && !dragging,
                }"
              >
                <div
                  class="d-inline-block text-center mr-15"
                  style="width: 16px; max-width: 16px"
                >
                  <img :src="require('@components_system/Shared/Images/Icon/Header.svg')" />
                </div>
                <div class="d-inline-block">
                  <span class="fs-14">{{ $t("engine.sidebar.index.lblHeader", languageEngine) }}</span>
                </div>
              </PanelItem>

              <!-- Sections -->
              <!-- @change="dragChange" -->
              <draggable
                v-model="sections"
                @start="
                  dragging = true;
                  elHover({ elementID: undefined });
                "
                :move="checkMove"
                @end="dragging = false"
                v-bind="dragOptions"
                class="sections-draggable"
              >
                <!-- handle=".handle" -->
                <transition-group type="transition" name="flip-list">
                  <!-- <template v-for="(section_key, index_section) in sections">
                    <PanelItem
                      v-if="components[section_key]"
                      :key="`index_section${index_section}`"
                      button
                      class="item-hover px-gd-2 py-6 mt-gd-1-nfc"
                      :class="{
                        hover: hoverSection(components[section_key].id) && !dragging,
                      }"
                      @mouseover="!dragging && elHover({ elementID: 'HEADER' })"
                      @mouseleave="!dragging && elHover({ elementID: undefined })"
                      @click="!dragging && elActive({ elementID: 'header' })"
                    >
                      <div class="row -mx-4 align-items-center">
                        <div class="col-auto px-4">
                          <div class="text-center" style="height: 16px; max-height: 16px" v-html="getSectionIcon(components[section_key].type)"></div>
                        </div>
                        <div class="col px-4 text-truncate">
                          <span class="fs-sa-14">{{ getSectionName(components[section_key]) }}</span>
                        </div>
                        <div class="col-auto px-4 itmh-display">
                          <span>
                            <i class="fal fa-trash-alt fs-16 text-default"></i>
                          </span>
                        </div>
                      </div>
                    </PanelItem>
                  </template> -->

                  <template v-for="(section_key, index_section) in sections">
                    <PanelItem
                      v-if="components[section_key]"
                      :key="`index_section${index_section}`"
                      button
                      class="mt-gd-1-nfc cursor-pointer"
                      :class="{
                        hover: hoverSection(components[section_key].id) && !dragging,
                      }"
                      @mouseover="!dragging && elHover({ elementID: components[section_key].id })"
                      @mouseleave="!dragging && elHover({ elementID: undefined })"
                      @click="!dragging && elActive({ elementID: ['component', components[section_key].id] })"
                    >
                      <div class="d-flex flex-wrap" v-if="!(section_key == isRenameActive)">
                        <!-- Icon -->
                        <div class="text-center pr-15" style="width: 31px; max-width: 31px" v-html="getSectionIcon(components[section_key].type)"></div>
                        <!-- Name -->
                        <div
                          class="flex-grow-1 w-50 pr-15"
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                          :title="getSectionName(components[section_key])"
                          @click.stop.prevent
                          @dblclick.stop.prevent="section_key == 'SECTION_PAGE' ? '' : toggleRename(section_key)"
                        >
                          <span class="fs-14">{{
                            getSectionName(components[section_key])
                          }}</span>
                        </div>
                        <!-- Tools -->
                        <div v-if="components[section_key].type == 'SECTION' || components[section_key].type == 'SLIDE_SECTION'">
                          <span
                            class="disabled text-muted"
                            v-if="
                              components[section_key].properties.isEnable === false
                            "
                          >
                            <i class="far fa-eye-slash fs-14"></i>
                          </span>
                          <div
                            class="panel-tool"
                            v-if="hoverSection(components[section_key].id)"
                            @click.stop.self.prevent
                          >
                            <span
                              v-b-tooltip.hover
                              :title="$t('engine.sidebar.index.panelItem.editName', languageEngine)"
                              @click="toggleRename(section_key)"
                            >
                              <i class="far fa-edit fs-14"></i>
                            </span>
                            <span
                              @click="disabled(section_key)"
                              title="Disable"
                              v-show="components[section_key].properties.isEnable"
                            >
                              <i class="far fa-eye fs-14 mx-10"></i>
                            </span>
                            <span
                              @click="disabled(section_key)"
                              title="Enable"
                              v-show="!components[section_key].properties.isEnable"
                            >
                              <i class="far fa-eye-slash fs-14 mx-10"></i>
                            </span>
                            <span @click="remove(section_key)" title="Delete">
                              <i class="far fa-trash-alt fs-14"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- Form Name -->
                      <div
                        class="d-flex align-items-center"
                        ref="input1"
                        v-if="section_key == isRenameActive"
                      >
                        <b-form-input
                          @click.stop.self.prevent
                          id="rename"
                          class="p-0 ml-5"
                          style="height: 24px; width: 230px; font-size: 14px"
                          @blur="toggleRename()"
                          @keydown.enter="submitRename(section_key)"
                          v-model="sectionName"
                        ></b-form-input>
                        <b-button
                          @click.stop.self.prevent
                          class="ml-10 px-5 d-flex align-items-center"
                          style="font-size: 12px; height: 24px"
                          variant="blue"
                          @click="submitRename(section_key)"
                          >Done</b-button
                        >
                      </div>
                    </PanelItem>
                  </template>
                </transition-group>
              </draggable>

              <!-- Footer -->
              <PanelItem
                button
                id="footer-section"
                class="d-flex align-items-cente mt-gd-1"
                @mouseover="!dragging && elHover({ elementID: 'FOOTER' })"
                @mouseleave="!dragging && elHover({ elementID: undefined })"
                @click="!dragging && elActive({ elementID: 'footer' })"
                :class="{
                  hover: hoverSection('FOOTER') && !dragging,
                }"
              >
                <div
                  class="d-inline-block text-center mr-15"
                  style="width: 16px; max-width: 16px"
                >
                  <img :src="require('@components_system/Shared/Images/Icon/Footer.svg')" />
                </div>
                <div class="d-inline-block">
                  <span class="fs-14">{{ $t("engine.sidebar.index.lblFooter", languageEngine) }}</span>
                </div>
              </PanelItem>
            </div>
          </template>
        </div>
      </div>

      <div class="panel-sticky-button pt-gd-1">
        <div v-if="!isExamplePage">
          <!-- Button Add Section -->
          <PanelItemAddSection
            id="add-section-btn"
            class="fs-14 text-center mt-gd-1-nfc"
            button
            @click="addSections"
          >
            <i class="fas fa-plus-circle mr-1"></i>
            {{ $t("engine.sidebar.index.btnAddSection", languageEngine) }}
          </PanelItemAddSection>
        </div>
        <HorizontalLine class="my-gd-2 bg-gray-light"/>
        <div>
          <!-- Appearance -->
          <PanelItem
            button
            class="d-flex align-items-center mt-gd-1-nfc"
            id="appearance"
            @click="!dragging && elActive({ elementID: 'website_theme' })"
          >
            <!-- @click="display_appearance = true" -->
            <img
              :src="require(`@assets/images/sidebar/appearance.svg`)"
              style="height: 18px"
            />
            <div class="fs-14 pl-10">{{ $t("engine.manageAppearance.lblTitle", languageEngine) }}</div>
          </PanelItem>
        </div>
      </div>
    </div>

    <Overlay></Overlay>
    <OverlayInsert></OverlayInsert>
    <AddPage
      :action="action"
      :id="sitePageID"
      :custom_id="`-sidebar`"
      :custom_open="null"
      @clear="action = ''"
    />
  </Wrapper>
</template>

<script>
import AddPage from "@components_system/Design/Modal/AddPage/AddPage";
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import Overlay from "./Overlay/Overlay";
import OverlayInsert from "./OverlayInsert/OverlayInsert";
import {
  Wrapper,
  HorizontalLine,
  PanelItem,
  PanelItemAddSection,
} from "./SidebarDesign.styled";

export default {
  components: {
    AddPage,
    Wrapper,
    HorizontalLine,
    draggable,
    Overlay,
    OverlayInsert,
    PanelItem,
    PanelItemAddSection,
  },
  data() {
    return {
      dragging: false,
      action: "",
      isRenameActive: "",
      sectionName: "",
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      elHoverID: "design/component/elHoverID",
      CONTENT_CONTAINER: "design/metadata/CONTENT_CONTAINER",
      components: "design/metadata/components",
      pageName: "design/page/pageName",
      sitePageID: "design/metadata/sitePageID",
      siteMainPageID: "design/metadata/siteMainPageID",
      isExamplePage: "design/page/isExamplePage",
      limit: "design/page/limit",
      modal: "design/modal",
    }),

    sections: {
      get() {
        return this.CONTENT_CONTAINER.componentsID;
      },
      set(sections) {
        this.CONTENT_CONTAINER.componentsID = sections;
        this.$store.dispatch("design/snapshot/genSnapshot");
      },
    },
    header: {
      get() {
        return this.$store.state.design.screen.header;
      },
      set(header) {
        return this.$store.dispatch("design/setHeader", { header });
      },
    },
    footer: {
      get() {
        return this.$store.state.design.screen.footer;
      },
      set(footer) {
        return this.$store.dispatch("design/setFooter", { footer });
      },
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: this.isRenameActive ? true : false,
        ghostClass: "ghost",
      };
    },
    isSectionPage() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf("SECTION_PAGE");
      return index == -1 ? false : true;
    },
    lastSectionIndex() {
      return this.CONTENT_CONTAINER.componentsID.length - 1;
    },
    selectedPageName(){
      let text = ''
      switch(this.pageName){
        case 'Blog':
          text = this.$t('engine.topbar.page.lblBlog', this.languageEngine)
          break
        case 'Post':
          text = this.$t('engine.topbar.page.lblPost', this.languageEngine)
          break
        case 'Photo':
          text = this.$t('engine.topbar.page.lblAlbum', this.languageEngine)
          break
        case 'Photo Album':
          text = this.$t('engine.topbar.page.lblAllAlbum', this.languageEngine)
          break
        case 'All Product':
          text = this.$t('engine.topbar.page.lblProductAll', this.languageEngine)
          break
        case 'Product Detail':
          text = this.$t('engine.topbar.page.lblProductDetail', this.languageEngine)
          break
        default:
          text = this.pageName
      }
      return text;
    }, 
    lblExample() {
      return this.isExamplePage ? `(${this.$t('engine.topbar.page.lblTitleExamplePage', this.languageEngine)})` : ''
    }
  },
  methods: {
    checkMove: function (evt) {
      return evt ? true : false;
    },
    managepage() {
      this.action = "edit";
      this.$bvModal.show("modal-add-page-sidebar");
    },
    toggleRename(section_key) {
      if (section_key) {
        this.isRenameActive = section_key;
        this.sectionName = this.components[section_key].properties.name;
        this.$nextTick(() => document.getElementById("rename").focus());
      } else {
        setTimeout(() => (this.isRenameActive = ""), 350);
      }
    },
    submitRename(section_key) {
      this.components[section_key].properties.name = this.sectionName;
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.isRenameActive = "";
    },
    disabled(section_key) {
      this.components[section_key].properties.isEnable =
        !this.components[section_key].properties.isEnable;
      this.$store.dispatch("design/snapshot/genSnapshot");
    },
    remove(section_key) {
      this.$store.dispatch("designIframe/component/removeSection", {
        id: section_key,
      });
    },
    hoverSection(elementID) {
      return this.elHoverID.indexOf(elementID) > -1 ? true : false;
    },

    elHover({ elementID }) {
      this.$store.dispatch("design/component/elHover", { elementID });

      if (elementID == "HEADER" || elementID == "FOOTER") {
        // Header or Footer Section
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {
          component_id: elementID == "HEADER" ? "comp-HEADER" : "FOOTER",
          name: elementID,
        });
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
      } else {
        this.$store.dispatch("designIframe/frame/setSectionHover", {
          component_id: elementID,
          name: elementID,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      }

      if (elementID) {
        setTimeout(() => {
          if (this.hoverSection(elementID) && !this.dragging) {
            this.$store.dispatch("design/component/scrollToId", {
              elementID,
              behavior: "smooth",
            });
          }
        }, 400);
      }
    },
    elActive({ elementID }) {
      setTimeout(() => {
        if (elementID == "header" || elementID == "footer") {
          // Header or Footer Section
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {
            component_id: elementID == "header" ? "comp-HEADER" : "FOOTER",
            name: elementID == "header" ? "HEADER" : "FOOTER",
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
          this.$store.dispatch("designIframe/frame/setSectionHover", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {});
          this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
          this.$store.dispatch("design/component/elActive", { elementID });
        } else {
          if (this.components[elementID[1]] && this.components[elementID[1]].type == "SLIDE_SECTION") {
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
              component_id: elementID[1],
              index: 0,
            });
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("design/component/elActive", { elementID: [
              ...elementID, this.components[elementID[1]].componentsID[0]
            ] });
          } else {
            // Other Section
            if (elementID && elementID != 'website_theme') {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: elementID[1],
                name: elementID[1],
              });
            }
            
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});

            if (elementID)
              this.$store.dispatch("design/component/scrollToId", {
                elementID,
                behavior: "smooth",
              });
      
            let noneSetting = false;
      
            SECTION_TYPE_NONE_SETTING.find((type) => {
              Object.entries(this.components).forEach((item) => {
                if (type === item[1].type && item[1].id === elementID[1]) {
                  noneSetting = true;
                }
              });
            });
            if (noneSetting) {
              this.$store.dispatch("design/component/elActive", {});
            } else {
              this.$store.dispatch("design/component/elActive", { elementID });
            }
          }
        }
      }, 100);
    },
    addSections() {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section)
      this.$store.dispatch("design/setMode", { mode: "add_section" });
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
        // this.$bvModal.show("modal-alert-limit-section");
      }
    },
    getSectionName(section) {
      if (section.type == "SECTION" || section.type == "SLIDE_SECTION") {
        return section.properties.name;
      } else if (section.type == 'SECTION_PAGE_POLICY') {
        if (section.data.policyType == 'privacy') {
          return this.$t("engine.common.sectionName.SECTION_PAGE_POLICY_PRIVACY", this.languageEngine);
        } else if (section.data.policyType == 'cookie') {
          return this.$t("engine.common.sectionName.SECTION_PAGE_POLICY_COOKIE", this.languageEngine);
        } 
        return '';
      } else {
        return this.$t("engine.common.sectionName." + section.type, this.languageEngine);
      }
    },
    getSectionIcon(cmpType) {
      switch (cmpType) {
        case "SECTION": return '<i class="far fa-ellipsis-v fs-16 text-gray-light cursor-move"></i>';
        case "SLIDE_SECTION": return '<i class="far fa-ellipsis-v fs-16 text-gray-light cursor-move"></i>';
        case "SECTION_PAGE_PRODUCT": return '<span style="width: 16px; max-width: 16px"><img src="' + require("@components_system/Shared/Images/Icon/SectionPageProduct.svg") + '"/></span>';
        case "SECTION_PAGE_FORM_ITEM": return '<i class="far fa-tasks fs-16 text-gray-light"></i>';
        case "SECTION_PAGE_QUOTATION_FORM_ITEM": return '<i class="far fa-tasks fs-16 text-gray-light"></i>';
        default: return '<i class="far fa-cog fs-16 text-gray-light"></i>';
      }
    },
  },
  mounted() {},
};
</script>

<style>
:root {
  --sidebar-width: 344px;
}
</style>